import { render, staticRenderFns } from "./Handoff.vue?vue&type=template&id=0d006b6e"
import script from "./Handoff.vue?vue&type=script&lang=js"
export * from "./Handoff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports